import { BaseService } from '@/modules/Core/services/BaseService'
import type { IBDPaciente, IConfBasedatosPacientes } from '@/modules/Administracion/interfaces'
import type { IResponseApi, IResponseApiSearch } from '@/modules/Core/interfaces/api/IApis'
import type { AxiosResponse } from 'axios'
export class BasedatosPacientesService extends BaseService<IConfBasedatosPacientes> {
  constructor () {
    super({
      baseUrl: 'scheduling/database-patient/'
    })
  }
  async getDbPorPaciente (
    id: number,
    fecha: string
  ): Promise<AxiosResponse<IResponseApi<IBDPaciente[]>>> {
    return this.http.get<IResponseApi<IBDPaciente[]>>(`/list-bd/${id}/${fecha}`)
  }
  async searchPacientes (
    id: string,
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApiSearch<IConfBasedatosPacientes[]>>> {
    return this.http
      .get<IResponseApiSearch<IConfBasedatosPacientes[]>>(`/search/${id}`, { params })
      .catch(this.errorHandle)
  }
  // Eliminar un elemento por ID
  async bulkDelete (
    pacientes: object
  ): Promise<AxiosResponse<IResponseApi<void>>> {
    return this.http.post<void>(`/delete-bulk`,  pacientes ).catch(this.errorHandle)
  }
  async transfer (
    pacientes: object,
    cobdId: number
  ): Promise<AxiosResponse<IResponseApi<void>>> {
    return this.http.post<void>(`/traslate/${cobdId}`,pacientes).catch(this.errorHandle)
  }
}
